import React, {Fragment, FunctionComponent, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {ConnectionState, JanusStatus} from "../../../constants/Janus";
import useJanus from "../../../hooks/Conference/Janus/useJanus";
import {Button} from "antd";
import {useVRoomPub} from "../../../hooks/Conference/Janus/useVRoomPub";
import RemoteFeed from "../../../components/Conference/RemoteFeed";
import {useAudioBridge} from "../../../hooks/Conference/Janus/useAudioBridge";
import shortid from 'shortid';
import {getGridArea, getScreenV2} from "../VideoConference/utils/janusUtils";

interface VideoCallProps {

}

export const VideoCall: FunctionComponent<VideoCallProps> = (props) => {

    const myVideoRef = useRef<any>(null);
    const audioRef = useRef<any>(null);
    const [first, setFirst] = useState<boolean>(true);
    const [username, setUsername] = useState<string>('peradona');
    const [displayPostfix, setDisplayPostfix] = useState<string>("");

    const janus = useJanus({
        server: "wss://janus-legacy.conf.meetecho.com/ws",
        // server: "wss://janus.conf.meetecho.com/ws",
        useSocket: false,
        socketState: ConnectionState.Connected,
        //@ts-ignore
        JanusModule: window.Janus,
    })

    const publisher = useVRoomPub({
        //@ts-ignore
        JanusModule: window.Janus,
        janusInstance: janus.janusInstance,
        janusStatus: janus.janusStatus,
        onLocalStream: (Janus: any, stream: any) => {
            Janus.attachMediaStream(myVideoRef.current, stream);
        }
    })

    const audioBridge = useAudioBridge({
        //@ts-ignore
        JanusModule: window.Janus,
        janusInstance: janus.janusInstance,
        janusStatus: janus.janusStatus,
        onRemoteStream: (Janus: any, stream: any) => {
            Janus.attachMediaStream(audioRef.current, stream);
        }
    })

    // const videoPlugin = useMVideoRoom({
    //     janusInstance: janus.janusInstance,
    //     janusStatus: janus.janusStatus,
    //     onLocalTrack: (janusModule, stream) => {
    //         // janusModule.attachMediaStream(myVideoRef.current, stream);
    //     },
    //     onStreams: (streams) => {
    //
    //     }
    // })

    useEffect(() => {
        let postfix = shortid.generate();
        setDisplayPostfix(postfix);
    }, [])

    useEffect(() => {
        if (janus.janusStatus === JanusStatus.Success) {
            publisher.attachPubPlugin();
            audioBridge.attachAudioBridgePlugin();
        }
    }, [janus.janusStatus])

    // useEffect(() => {
    //     if (publisher.pluginStatus === PluginStatus.Attached && displayPostfix) {
    //         //@ts-ignore
    //         publisher.joinRoom(1234, `${username}-${displayPostfix}`);
    //     }
    // }, [publisher.pluginStatus, displayPostfix])
    //
    // useEffect(() => {
    //     if (audioBridge.pluginStatus === PluginStatus.Attached && displayPostfix) {
    //         //@ts-ignore
    //         audioBridge.joinRoom(1234, `${username}-${displayPostfix}`)
    //     }
    // }, [audioBridge.pluginStatus, displayPostfix])
    //
    // useEffect(() => {
    //     if (!publisher.joined) return;
    //     publisher.publishCamera(false);
    // }, [publisher.joined])
    //
    // useEffect(() => {
    //     if (!audioBridge.joined) return;
    //     audioBridge.publishAudioBridge();
    // }, [audioBridge.joined])

    // useEffect(() => {
    //     if (myVideoRef.current && videoPlugin.stream) {
    //         videoPlugin.janusModule.attachMediaStream(myVideoRef.current, videoPlugin.stream);
    //     }
    // }, [myVideoRef.current, videoPlugin.stream])
    //
    // useEffect(() => {
    //     console.log("publisher.publishers", publisher.publishers);
    // }, [publisher.publishers])

    const renderRemoteFeed = useCallback((pub: any, index: number) => {
        return (
            <Fragment key={"video-feed-" + pub.id}>
                <div
                    className={`${getGridArea(index)}`}
                >
                    <RemoteFeed
                        key={index}
                        janusInstance={janus.janusInstance}
                        janusStatus={janus.janusStatus}
                        //@ts-ignore
                        JanusModule={window.Janus}
                        room={1234}
                        pvtId={publisher.privateId}
                        publisher={pub}
                        // id={pub.id}
                        // display={pub.display}
                        // audio={pub.audio}
                        // video={pub.video}
                        onCleanup={publisher.publisherLeft}
                    />
                </div>
            </Fragment>
        )
    }, [janus.janusInstance, publisher.publishers, publisher.privateId])

    const renderPublishers = useMemo(() => {
        if (!publisher.joined || !publisher.privateId || !janus.janusInstance) return
        return (
            <div className={`${getScreenV2(publisher.publishers.length, false)}`} style={{ display: "grid" }}>
                {
                    publisher.publishers.map((pub: any, index: number) => {
                        return renderRemoteFeed(pub, index)
                    })
                }
            </div>
        )
    }, [janus.janusInstance, publisher.publisherLeft, publisher.publishers, publisher.privateId, publisher.joined])

    const mergeParticipants = useMemo(() => {
        return audioBridge.participants.filter((participant: any) => {
            return !publisher.publishers.some((pub: any) => pub.display === participant.display)
        })
    }, [audioBridge.participants, publisher.publishers])

    const renderAudio = useMemo(() => {
        return (
            <Fragment>
                {
                    mergeParticipants.map((participant: any, index: number) => {
                        return (
                            <div>
                                {participant.display}
                            </div>
                        )
                    })
                }
            </Fragment>
        )
    }, [janus.janusInstance, mergeParticipants, audioBridge.joined])

    const showList = () => {
        let list = { request: "list" };
        publisher.videoPlugin.send(
            {
                message: list,
            }
        )
    }

    const list = () => {
        let list = { request: "list" };
        publisher.videoPlugin.send(
            {
                message: list,
                success: async function (result: any) {
                    console.log("result", result);
                    for (let room of result.list) {
                        let destroyRoom = {request: "destroy", room: room.room};
                        publisher.videoPlugin.send({
                            message: destroyRoom
                        })
                    }
                }
            })
    }

    const edit = () => {
        let ed = {
            request: "edit",
            room: 1515164486991396,
            new_bitrate: 256000,
            new_fir_freq: 10,
        }
                // "secret" : "<room secret, mandatory if configured>",
                // "new_description" : "<new pretty name of the room, optional>",
                // "new_secret" : "<new password required to edit/destroy the room, optional>",
                // "new_pin" : "<new password required to join the room, optional>",
                // "new_is_private" : <true|false, whether the room should appear in a list request>,
                // "new_require_pvtid" : <true|false, whether the room should require private_id from subscribers>,
                // "new_bitrate" : <new bitrate cap to force on all publishers (except those with custom overrides)>,
                // "new_fir_freq" : <new period for regular PLI keyframe requests to publishers>,
                //     "new_publishers" : <new cap on the number of concurrent active WebRTC publishers>,
                //         "new_lock_record" : <true|false, whether recording state can only be changed when providing the room secret>,
                //         "new_rec_dir" : "<the new path where the next .mjr files should being saved>",
                //         "permanent" : <true|false, whether the room should be also removed from the config file, default=false>
                //         }
                //
                //         }
        publisher.videoPlugin.send({ message: ed });
    }

    return (
        <div>
            <div>janusStatus: {janus.janusStatus}</div>
            <div>myId: {publisher.id}</div>
            <div>myPrivateId: {publisher.privateId}</div>
            <div>consentDialog: {publisher.consentDialog  ? "on" : "off"}</div>
            <div>iceState: {publisher.iceState}</div>
            <div>mediaState: {publisher.mediaState?.medium} {publisher.mediaState?.on ? "started" : "stopped"} {publisher.mediaState?.mid}</div>
            <div>webrtcState: {publisher.webrtcState === true ? "on" : "down"}</div>
            <Button onClick={() => {setFirst(!first)}}>switch</Button>
            <Button onClick={audioBridge.toggleAudio}>{audioBridge.muted ? "unmute" : "mute"}</Button>
            <Button onClick={() => {
                publisher.webrtcState ?
                    publisher.unpublish() :
                    publisher.publishCamera()
            }}>{!publisher.webrtcState ? "publish" : "unpublish"}</Button>
            <Button onClick={showList}>list</Button>
            <Button onClick={list}>destroy all room</Button>
            <Button onClick={edit}>edit</Button>
            <audio ref={audioRef} autoPlay/>
            {first ?
                <video id="video" autoPlay ref={myVideoRef} width={500} height={500}></video> :
                <video id="video" autoPlay ref={myVideoRef} width={1000} height={1000}></video>
            }
            <div style={{ width: "100%", height: "50vh"}}>
                {renderPublishers}
            </div>
            {renderAudio}
        </div>
    )
}
